module.exports = __webpack_public_path__ + "img/01.9755f7a3.png";